import React, { Fragment, useContext, useEffect, useState } from "react";
import FContainer from "../../components/FContainer/FContainer";
import "./style/notificationStyle.css"
import { ArrowCircleDownIcon, ArrowCircleUpIcon } from "@heroicons/react/outline";
import { useNotification } from "../../hooks/useNotification";
import { useCurrencyFormat } from "../../hooks/useCurrencyFormat";
import { useProcessor } from "../../hooks/useProcessor";
import { v4 as uuidv4 } from 'uuid'
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { size } from "lodash";
import FiconPhoneNumber from "../../components/FiconPhoneNumber/FiconPhoneNumber";
import { useFormat } from "../../hooks/useFormat";
import InfiniteScroll from 'react-infinite-scroll-component';
import { Trash } from "react-ionicons";
import { AuthContext } from "../../context/AuthContext";

const NotificationScreen = ({ param }) => {
  const { getNotification, updateNotificationStatus, deleteNotification } = useNotification();
  const { formatWithCurrencyISO } = useCurrencyFormat();
  const { processPayment } = useProcessor();
  const route = useNavigate()
  const { formatDateHour } = useFormat();
  const [toggleState, setToggleState] = useState(1);
  const [idempotencyKey, setIdempotencyKey] = useState('');
  const [statusTab, setStatusTab] = useState('PENDING');
  const [page, setPage] = useState(1);
  const [totalComplete, setTotalComplete] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const { notificationsSocket, setNotificationsSocket,
    totalPending, setTotalPending
  } = useContext(AuthContext);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  useEffect(() => {

    const _getNotification = async () => {
      let res = await getNotification(statusTab, 1, false)
      setPage(1)
      if (res[0]) {

        res[1].page.map(r => {
          r.idempotencyKey = uuidv4()
        })
        setNotifications(res[1]);
        console.log(notificationsSocket)
      } else {
        setNotifications([]);
      }
    };


    if (!!notificationsSocket) {
      if (notificationsSocket.messageType == "REQUEST_FIADO_SHARE" ||
        notificationsSocket.messageType == 'REQUEST_FIADO_SHARE_REJECTED' ||
        notificationsSocket.messageType == 'PUSH_RECIEVE_MONEY' ||
        notificationsSocket.messageType == 'REQUEST_FIADO_SHARE_CANCEL') {
        _getNotification();
      }
    }

  }, [notificationsSocket]);


  useEffect(() => {


    setNotifications([]);
    const _getNotification = async () => {
      let res = await getNotification(statusTab, 1)
      setPage(1)
      if (res[0]) {
        res[1].page.map(r => {
          r.idempotencyKey = uuidv4()
        })
        setNotifications(res[1]);
      } else {
        setNotifications([]);
      }
    };
    _getNotification();
  }, [statusTab])

  const nextScreen = async ({ amount, beneficiaryDirectoryId, concept = null, requestId, idempotency }) => {

    const data = {
      originCurrencyId: "484",
      destinationCurrencyId: "484",
      exchangeRateId: null,
      products: [
        {
          id: "FIADO_FUNDS_AVAILABLE_MXN"
        },
        {
          id: "FIADO_SHARE_MXN",
          amount: amount,
          beneficiaryDirectoryId: beneficiaryDirectoryId,
          typeOfDirectoryId: "USER",
          concept: concept,
          saveAsFavorite: false,
          requestId: requestId
        }
      ]
    }

    let response = await processPayment(data, idempotency);
    if (response?.data?.code === "PROCESS_OK") {
      notifications.page = notifications.page.filter(noti => noti.id != requestId)
      setTotalPending(totalPending - 1)
      Swal.fire({
        showCloseButton: true,
        title: 'Éxito',
        text: 'La transferencia se ha realizado exitosamente',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        confirmButtonText: 'Entendido'
      })
    }
  }

  useEffect(() => {
    if (statusTab == "PENDING") {
      setTotalPending(notifications.totalRecords)
    } else {

    }
  }, [notifications])

  const fetchMoreData = () => {
    if (page + 1 <= notifications.totalPages) {
      const _getNotification = async () => {
        let res = await getNotification(statusTab, page + 1)
        setPage(page + 1)
        res[1].page = notifications.page.concat(res[1].page)
        setNotifications(res[1])
      }
      _getNotification();
    }
  };

  return (
    <>
      <FContainer>
        <div className="sm:block w-full">
          <div className="border-0 border-gray-200">
            <nav className="-mb-px flex" aria-label="Tabs">
              <a
                className={classNames(
                  toggleState === 1
                    ? 'tab-active'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                  'flex-1 py-4 px-1 text-center border-b-2 font-medium text-sm cursor-pointer'
                )}
                aria-current={toggleState === 1 ? 'page' : undefined}
                onClick={() => {
                  setStatusTab('PENDING')
                  toggleTab(1)
                }}
              >
                Pendientes ( {!totalPending ? 0 : totalPending} )
              </a>
              <a
                className={classNames(
                  toggleState === 2
                    ? 'tab-active'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                  'flex-1 py-4 px-1 text-center border-b-2 font-medium text-sm cursor-pointer'
                )}
                aria-current={toggleState === 2 ? 'page' : undefined}
                onClick={() => {
                  setStatusTab('COMPLETED')
                  toggleTab(2)
                }}
              >
                Completados
              </a>
            </nav>
          </div>

          <div className="content-tabs">
            <div
              className={toggleState === 1 ? "content  active-content" : "content"}
            >
              {
                notifications &&
                <InfiniteScroll
                  dataLength={size(notifications.page)}
                  next={fetchMoreData}
                  hasMore={true}
                >
                  {notifications.page && (notifications.page).map((notification, index) => {
                    return (
                      <div className="border w-full rounded-2xl px-2 py-3 my-2" key={index}>
                        <div className="border-0 card-notification-header">

                          {notification.typeOfMessage === 'REQUEST_FIADO_SHARE' ? <ArrowCircleUpIcon className="!h-[20px] !w-[20px] border-0 card-notification-icon" color={'#E30000'} /> : <ArrowCircleDownIcon className="!h-[20px] !w-[20px] card-notification-icon" color={'#2A9F52'} />}
                          <h2 className="card-title border-0 w-full">
                            {notification.typeOfMessage == 'REQUEST_FIADO_SHARE' ? (
                              <>
                                <div className="border-0 float-left">{notification.beneficiary.preferredName.split(" ")[0]}</div>
                                <div className="text-[15px] float-left pl-2 pt-1">
                                  <FiconPhoneNumber
                                    sizeIcon="18px"
                                    phoneNumber={notification.beneficiary.phoneNumber}
                                  />
                                </div>
                                <br />
                                <div className="border-0 text-[15px] grid place-content-start w-full">
                                  Te ha pedido {formatWithCurrencyISO(notification.message.options.amount, notification.message.options.currency)}
                                </div>
                                <div className="border-0 text-[15px] grid place-content-start w-full">
                                  <p className="card-description-text">{`${notification.concept}`} </p>
                                </div>
                              </>
                            ) :
                              <>
                                <div className="border-0 float-left">{notification.requestTo.preferredName}</div>
                                <div className="text-[15px] float-left pl-2 pt-1">
                                  <FiconPhoneNumber
                                    sizeIcon="18px"
                                    phoneNumber={notification.requestTo.phoneNumber}
                                  />
                                </div>
                                <br />
                                <div className="border-0 text-[15px] grid place-content-start w-full">
                                  Tú le pediste {formatWithCurrencyISO(notification.message.options.amount, notification.message.options.currency)}
                                </div>
                                <div className="border-0 text-[15px] grid place-content-start w-full">
                                  <p className="card-description-text">{`${notification.concept}`} </p>
                                </div>
                              </>

                            }
                          </h2>
                        </div>
                        <div className="flex border-0">
                          <button
                            type="button"
                            className="button-notification"
                            onClick={async () => {
                              notifications.page = notifications.page.filter(noti => noti.id != notification.id)
                              setTotalPending(totalPending - 1)
                              const resp = updateNotificationStatus(notification.id, {
                                status: (notification.typeOfMessage === 'REQUEST_FIADO_SHARE' ? 'REJECTED' : 'CANCEL')
                              })

                              if (await resp == true) {
                                getNotification(statusTab, page);
                              }

                            }}
                          >
                            {notification.typeOfMessage === 'REQUEST_FIADO_SHARE' ? 'Rechazar' : 'Cancelar'}
                          </button>
                          {
                            notification.typeOfMessage === 'REQUEST_FIADO_SHARE' ?
                              <button
                                type="button"
                                className="button-notification button-confirm"
                                onClick={() => {
                                  nextScreen({
                                    amount: notification.message.options.amount,
                                    beneficiaryDirectoryId: notification.message.options.beneficiaryDirectoryId,
                                    concept: notification.message.options.concept,
                                    requestId: notification.id,
                                    idempotency: notification.idempotencyKey
                                  })
                                }}
                              >
                                Aceptar
                              </button>
                              : null
                          }
                          <p className="card-description-text py-2 border-0 text-right pr-2">{`${formatDateHour(notification.creationDate)}`} </p>

                        </div>
                      </div>
                    )
                  })}
                </InfiniteScroll>
              }
              {
                size(notifications) < 1 ?
                  <div className="flex justify-center">
                    <h2 className="text-2xl text-gray-500">No hay notificaciones pendientes</h2>
                  </div>
                  : null
              }
            </div>
            <div
              className={toggleState === 2 ? "content  active-content" : "content"}
            >

              {
                notifications &&

                <InfiniteScroll
                  dataLength={size(notifications.page)}
                  next={fetchMoreData}
                  hasMore={true}
                >
                  {notifications.page && (notifications.page).map((notification, index) => {
                    return (
                      <div className="border w-full rounded-2xl px-2 py-3 my-2" key={index}>
                        <div className="border-0 card-notification-header">

                          {notification.typeOfMessage === 'REQUEST_FIADO_SHARE' ? <ArrowCircleUpIcon className="!h-[20px] !w-[20px] border-0 card-notification-icon" color={'#E30000'} /> : <ArrowCircleDownIcon className="!h-[20px] !w-[20px] card-notification-icon" color={'#2A9F52'} />}
                          <h2 className="card-title border-0 w-full">
                            {notification.typeOfMessage == 'REQUEST_FIADO_SHARE' ? (
                              <>
                                <div className="border-0 float-left">{notification.beneficiary.preferredName}</div>
                                <div className="text-[15px] float-left pl-2 pt-1">
                                  <FiconPhoneNumber
                                    sizeIcon="18px"
                                    phoneNumber={notification.beneficiary.phoneNumber}
                                  />
                                </div>
                                <br />
                                <div className="border-0 text-[15px] grid place-content-start w-full">
                                  Te ha pedido {formatWithCurrencyISO(notification.message.options.amount, notification.message.options.currency)}
                                </div>
                                <div className="border-0 text-[15px] w-full">
                                  <p className="card-description-text">{`${notification.concept}`} </p>
                                </div>
                              </>
                            ) :
                              <>
                                <div className="border-0 float-left">{notification.requestTo.preferredName}</div>
                                <div className="text-[15px] float-left pl-2 pt-1">
                                  <FiconPhoneNumber
                                    sizeIcon="18px"
                                    phoneNumber={notification.requestTo.phoneNumber}
                                  />
                                </div>
                                <br />
                                <div className="border-0 text-[15px] grid place-content-start w-full">
                                  Tú le pediste {formatWithCurrencyISO(notification.message.options.amount, notification.message.options.currency)}
                                </div>
                                <div className="border-0 text-[15px] grid place-content-start w-full">
                                  <p className="card-description-text">{`${notification.concept}`} </p>
                                </div>
                              </>

                            }
                          </h2>
                          <div className="border-0 pr-2">
                            <button
                              type="button"
                              className="!border-2"
                              onClick={async () => {
                                Swal.fire({
                                  showCloseButton: true,
                                  title: `Eliminar Notificación`,
                                  text: `¿Está seguro que desea eliminar esta Notificación?`,
                                  imageUrl: require("../../components/assets/images/pregunta.png"),
                                  imageWidth: 150,
                                  imageHeight: 150,
                                  imageAlt: "Custom image",
                                  confirmButtonColor: "#28a745",
                                  cancelButtonColor: "#dc3545",
                                  showCancelButton: true,
                                  confirmButtonText: "Aceptar",
                                  cancelButtonText: "Cancelar",
                                  reverseButtons: true,
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    const _deleteNotification = async () => {
                                      let res = deleteNotification(notification.id)
                                      if (res) {
                                        notifications.page = notifications.page.filter(noti => noti.id != notification.id)
                                        setTotalComplete(totalComplete - 1)
                                      }
                                    };
                                    _deleteNotification();
                                  }
                                });
                              }}
                            >
                              <Trash
                                height="23px"
                                width="23px"
                                color={"#E30000"}
                              />
                            </button>
                          </div>
                        </div>
                        <div className="flex pt-1">
                          {notification.status === 'COMPLETED' ?
                            (
                              <div className="text-[#56b85c] font-bold text-[14px] pl-1">
                                Completado
                              </div>
                            ) : (
                              <div className="text-[red] font-bold text-[14px] pl-1">
                                Rechazado
                              </div>
                            )

                          }
                          <p className="card-description-text py-2 border-0 text-right pr-2">{`${formatDateHour(notification.creationDate)}`} </p>

                        </div>
                      </div>
                    )
                  })}
                </InfiniteScroll>
              }
              {
                size(notifications) < 1 ?
                  <div className="flex justify-center">
                    <h2 className="text-2xl text-gray-500">No hay notificaciones completadas</h2>
                  </div>
                  : null
              }
            </div>
          </div>
        </div>
      </FContainer>
    </>
  );
};

export default NotificationScreen;